module.exports = __webpack_public_path__ + "static/media/report_16-20_mobile.1d4c92f2.png";